import {
  createRegimenBuilderFlowSchema,
  createSkinAnalyzerFlowSchema,
  type FlowSchema,
} from './flow-schema.js';

export const STOREFRONT_LEAD_MAGNET_SLUGS = ['regimenbuilder', 'skin-analyzer'] as const;

/** Storefront lead flows that call `GET /catalog/routine-match` — need `routine:*` products before publish. */
export const ROUTINE_MATCH_LEAD_FLOW_SLUGS = STOREFRONT_LEAD_MAGNET_SLUGS;

export type RoutineMatchLeadFlowSlug = (typeof ROUTINE_MATCH_LEAD_FLOW_SLUGS)[number];

export function leadFlowRequiresRoutineProductTags(slug: string): slug is RoutineMatchLeadFlowSlug {
  return (ROUTINE_MATCH_LEAD_FLOW_SLUGS as readonly string[]).includes(slug);
}

export type StorefrontLeadMagnetSlug = (typeof STOREFRONT_LEAD_MAGNET_SLUGS)[number];

export type StorefrontLeadMagnetDefinition = {
  slug: StorefrontLeadMagnetSlug;
  defaultName: string;
  label: string;
  description: string;
  storefrontPath: string;
  createSchema: () => FlowSchema;
};

export const STOREFRONT_LEAD_MAGNETS: StorefrontLeadMagnetDefinition[] = [
  {
    slug: 'regimenbuilder',
    defaultName: 'Routine Builder',
    label: 'Routine sur mesure',
    description: 'Hub diagnostic + /flows/regimenbuilder — questionnaire routine',
    storefrontPath: '/flows/regimenbuilder',
    createSchema: createRegimenBuilderFlowSchema,
  },
  {
    slug: 'skin-analyzer',
    defaultName: 'Analyse peau IA',
    label: 'Analyse peau par caméra',
    description: 'Bloc accueil analyse peau → /flows/skin-analyzer',
    storefrontPath: '/flows/skin-analyzer',
    createSchema: createSkinAnalyzerFlowSchema,
  },
];

export function isStorefrontLeadMagnetSlug(slug: string): slug is StorefrontLeadMagnetSlug {
  return (STOREFRONT_LEAD_MAGNET_SLUGS as readonly string[]).includes(slug);
}

export type StorefrontLeadMagnetStatusItem = {
  slug: StorefrontLeadMagnetSlug;
  label: string;
  storefrontPath: string;
  exists: boolean;
  published: boolean;
  /**
   * Flow is openable on the storefront (exists + published + active).
   * Independent of catalog `routine:*` tags — those only affect product matching.
   */
  ready: boolean;
  flowId: string | null;
  flowName: string | null;
  /**
   * `missing` / `draft` = flow not wired.
   * `blocked` = flow published but catalog has no `routine:*` products (matching empty).
   * `ready` = wired + catalog can match.
   */
  status: 'missing' | 'draft' | 'ready' | 'blocked';
  /** Set when matching cannot run (no `routine:*` products on storefront). */
  blockReason?: string | null;
  routineTaggedProductCount?: number;
};

export type StorefrontLeadMagnetsStatus = Record<
  StorefrontLeadMagnetSlug,
  StorefrontLeadMagnetStatusItem
>;
